export default "__VITE_ASSET__BiQ179S0__"